import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Tab from '../../common/tab-timer';
import { getQueryParams } from '../../helpers/Common';
import BalanceSheet from './balance-sheeet/BalanceSheet';
import CashFlowStatement from './cash-flow-statement/CashFlowStatement';
import { TABS, TIME_FILTERS } from './Const';
import IncomeStatement from './income-statement/IncomeStatement';
import { REDUCER_NAME, updateSkip } from './reducer';
import ExportBlob from './common/export-blob';
import currentState from './../../helpers/CurrentState';
import ConstCommon from './../../common/Const';

const tabMap = {
  [TABS.BALANCE_SHEET]: BalanceSheet,
  [TABS.CASH_FLOW_STATEMENT]: CashFlowStatement,
  [TABS.INCOME_STATEMENT]: IncomeStatement,
};

const timeMap = {
  [TIME_FILTERS.QUARTERLY]: 'quarterly',
  [TIME_FILTERS.YEARLY]: 'yearly',
};

const mapTimeQuery = {
  quarterly: TIME_FILTERS.QUARTERLY,
  yearly: TIME_FILTERS.YEARLY,
};

class TabContent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      timeFilter:
        mapTimeQuery[getQueryParams('period')] || TIME_FILTERS.QUARTERLY,
    };
  }

  changeFilter = timeFilter => {
    const { componentId, updateSkip } = this.props;

    currentState.add(
      ConstCommon.listComponent.FinancialStatement,
      'timeFilter',
      timeFilter,
      componentId,
    );
    this.setState({
      timeFilter,
    });
    updateSkip(componentId, 0);
  };

  render() {
    const { timeFilter } = this.state;
    const { currentTab, organCode, componentId, currentSearch } = this.props;
    const ContentComponent = tabMap[currentTab];
    return (
      <div className="d-flex flex-column flex-fill">
        <div className="d-flex justify-content-end flex-shrink-0">
          <div className="mr-5">
            <Tab
              disableTabNormal={true}
              currentTab={timeFilter}
              listTab="financialStatement.timeTab"
              changeTab={this.changeFilter}
            />
          </div>
          <ExportBlob timeFilter={timeFilter} {...this.props} />
        </div>

        <ContentComponent
          currentSearch={currentSearch}
          componentId={componentId}
          organCode={organCode}
          timeKey={timeMap[timeFilter]}
          key={currentTab}
        />
      </div>
    );
  }
}

TabContent.propTypes = {
  currentTab: PropTypes.number.isRequired,
  organCode: PropTypes.string.isRequired,
  componentId: PropTypes.number.isRequired,
};

const mapStateToProps = (state, { componentId }) => ({
  organCode: state[REDUCER_NAME][componentId].currentSearch.code,
  currentSearch: state[REDUCER_NAME][componentId].currentSearch,
  displayCode: state[REDUCER_NAME][componentId].currentSearch.displayCode,
});

const mapDispatchToProps = {
  updateSkip,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TabContent);
